import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {schemaInterfaceURL as getCustomSchemaInterfaceURL} from 'schemas/schema-interface/SchemaInterfaceDAO';
import getSchemaInterfaceType from 'schemas/schema-interface/v2/getSchemaInterfaceType';
import {assertNever} from 'util/Types';

/**
 * Get (Custom or Static) Schema Interface URL
 *
 * Not all Interfaces have URLs. If this returns null, then the caller should *not* linkify the Interface.
 *
 * @returns URL if available, null if no URL is available
 */
export default function getSchemaInterfaceURL(interfaceId: string): string | null {
  const interfaceType = getSchemaInterfaceType(interfaceId);
  switch (interfaceType) {
    case DomainGraphType.FIELDSET:
      return getCustomSchemaInterfaceURL(interfaceId);
    case DomainGraphType.SYSTEM_CATEGORY:
      return null; // No URL
    default:
      throw Error(`Invalid interface type: ${assertNever(interfaceType)}`);
  }
}
